module.exports = __webpack_public_path__ + "static/media/Product Pic-14.add66276.jpg";